/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_GeneratingInputs */

const en_landing_studio_generating = /** @type {(inputs: Landing_Studio_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating…`)
};

const zh_landing_studio_generating = /** @type {(inputs: Landing_Studio_GeneratingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成中…`)
};

/**
* | output |
* | --- |
* | "Generating…" |
*
* @param {Landing_Studio_GeneratingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_generating = /** @type {((inputs?: Landing_Studio_GeneratingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_GeneratingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_generating(inputs)
	return zh_landing_studio_generating(inputs)
});
export { landing_studio_generating as "landing.studio.generating" }